import { AppBar, Tab, Tabs } from '@material-ui/core';
import TabPanel from 'components/common/tab/TabPanel';
import { T } from 'components/common/text';
import CustomText from 'components/common/text/CustomText';
import { a11yProps } from 'lib/library';
import { IToothShade } from 'lib/types/projectTypes';
import _ from 'lodash';
import React, { ChangeEvent } from 'react';
import { useShallowAppSelector } from 'store/hooks';
import styled from 'styled-components';
import { color } from 'styles/utils';
import AdvancedOption from './AdvancedOption';
import BasicOption from './BasicOption';
import OptionListSkeleton from './OptionListSkeleton';

interface OptionListProps {
  matchingImplantList: any;
  matchingAbutmentList: any;
  matchingScanbodyList: any;
  materialShadeList: IToothShade[];
  defaultOption: {
    inputs: {};
    onChange: (event: any) => void;
    setInputs: React.Dispatch<React.SetStateAction<{}>>;
    onReset: () => void;
  };
  advancedOption: {
    inputs: {};
    onChange: (event: any) => void;
    setInputs: React.Dispatch<React.SetStateAction<{}>>;
    onReset: () => void;
  };
  defaultValue: {
    inputs: {};
    onChange: (event: any) => void;
    setInputs: React.Dispatch<React.SetStateAction<{}>>;
    onReset: () => void;
  };
  advancedValue: {
    inputs: {};
    onChange: (event: any) => void;
    setInputs: React.Dispatch<React.SetStateAction<{}>>;
    onReset: () => void;
  };
  isBeElement: {
    checkBox: boolean;
    radioButton: boolean;
    slider: boolean;
  };
  indication: {
    value: {
      // id: number;
      id: string;
      seq: string;
      color: string;
    };
    onChange: (e: any) => void;
    setValue: (value: object) => void;
  };
  indicationOption: any;
  material: { value: string; onChange: (e: any) => void; setValue: (value: string) => void };
  restorationPontic: {
    value: number;
    onChange: (e: any) => void;
    setValue: (value: number) => void;
  };
  occlusalSurface: {
    value: number;
    onChange: (e: any) => void;
    setValue: (value: number) => void;
  };
  ceramicMetal: {
    value: number;
    onChange: (e: any) => void;
    setValue: (value: number) => void;
  };
  indicationSeq: {
    value: number;
    onChange: (e: any) => void;
    setValue: (value: number) => void;
  };
  implant: { value: number; onChange: (e: any) => void; setValue: (value: number) => void };
  abutment: {
    value: number | null;
    onChange: (e: any) => void;
    setValue: (value: number | null) => void;
  };
  scanbody: {
    value: number | null;
    onChange: (e: any) => void;
    setValue: (value: number | null) => void;
  };
  checkSituScan: {
    value: boolean | number;
    onChange: (e: any) => void;
    setValue: (value: boolean | number) => void;
  };
  checkGingivaScan: {
    value: boolean | number;
    onChange: (e: any) => void;
    setValue: (value: boolean | number) => void;
  };
  gapWidthCement: {
    value: number | number[] | string | any; // input value 입력시 string
    onChange: (e: any) => void;
    setValue: (value: number | number[] | string | any) => void;
  };
  minimalTickness: {
    value: number | number[] | string | any; // input value 입력시 string
    onChange: (e: any) => void;
    setValue: (value: number | number[] | string | any) => void;
  };
  millingToolDiameter: {
    value: number | number[] | string | any; // input value 입력시 string
    onChange: (e: any) => void;
    setValue: (value: number | number[] | string | any) => void;
  };
  virtualGingiva: {
    value: number;
    onChange: (e: any) => void;
    setValue: (value: number) => void;
  };
  thimbleCrown: {
    value: number;
    onChange: (e: any) => void;
    setValue: (value: number) => void;
  };
  waxupScan: {
    value?: number | null;
    onChange: (e: any) => void;
    setValue: (value?: number | null) => void;
  };
  cervicalAdaption: {
    value: number;
    onChange: (e: any) => void;
    setValue: (value: number) => void;
  };
  materialShade: { value: number; onChange: (e: any) => void; setValue: (value: number) => void };
  optionTab: number;
  onChooseImplant: (seq: number) => void;
  onChooseAbutment: (seq: number) => void;
  onChooseScanbody: (seq: number) => void;
  onClickTab: (event: ChangeEvent<{}>, newValue: number) => void;
}

function OptionList({
  defaultOption,
  advancedOption,
  defaultValue,
  advancedValue,
  isBeElement,
  matchingImplantList,
  matchingAbutmentList,
  matchingScanbodyList,
  materialShadeList,
  indication,
  indicationOption,
  material,
  indicationSeq,
  implant,
  abutment,
  scanbody,
  checkSituScan,
  checkGingivaScan,
  gapWidthCement,
  minimalTickness,
  millingToolDiameter,
  virtualGingiva,
  thimbleCrown,
  waxupScan,
  cervicalAdaption,
  materialShade,
  restorationPontic,
  occlusalSurface,
  ceramicMetal,
  optionTab,
  onClickTab,
  onChooseImplant,
  onChooseAbutment,
  onChooseScanbody,
}: OptionListProps) {
  const { indicationOptionPending } = useShallowAppSelector(state => ({
    indicationOptionPending: state.util.indicationOption.pending,
  }));
  return (
    <StyledOptionList>
      <div className="optionList__title">
        <CustomText fontSize={20} fontWeight={500}>
          <T>GLOBAL_OPTION</T>
        </CustomText>
      </div>
      {!!indication.value &&
        !_.isEmpty(indication.value) &&
        !!material.value &&
        material.value !== '0' && (
          <div className="optionList__container">
            <AppBar position="static">
              <Tabs
                value={optionTab}
                onChange={onClickTab}
                variant="fullWidth"
                TabIndicatorProps={{ style: { display: 'none' } }}
              >
                <Tab
                  label={
                    <CustomText
                      fontColor={optionTab === 0 ? '#00A6E2' : '#666'}
                      fontSize={14}
                      fontWeight={400}
                    >
                      <T>GLOBAL_BASIC_OPTION</T>
                    </CustomText>
                  }
                  {...a11yProps(0)}
                  className="optionList__tab_item"
                />
                <Tab
                  label={
                    <CustomText
                      fontColor={optionTab === 1 ? '#00A6E2' : '#666'}
                      fontSize={14}
                      fontWeight={400}
                    >
                      <T>GLOBAL_ADVANCED_OPTION</T>
                    </CustomText>
                  }
                  {...a11yProps(1)}
                  className="optionList__tab_item"
                />
              </Tabs>
            </AppBar>
            <div className="optionList__body">
              <TabPanel value={optionTab} index={0}>
                {!!indicationOptionPending ? (
                  <OptionListSkeleton type="default" />
                ) : (
                  <BasicOption
                    defaultOption={defaultOption}
                    defaultValue={defaultValue}
                    isBeElement={isBeElement}
                    matchingImplantList={matchingImplantList}
                    matchingAbutmentList={matchingAbutmentList}
                    matchingScanbodyList={matchingScanbodyList}
                    materialShadeList={materialShadeList}
                    indicationSeq={indicationSeq}
                    indicationOption={indicationOption}
                    implant={implant}
                    abutment={abutment}
                    scanbody={scanbody}
                    checkSituScan={checkSituScan}
                    checkGingivaScan={checkGingivaScan}
                    gapWidthCement={gapWidthCement}
                    minimalTickness={minimalTickness}
                    millingToolDiameter={millingToolDiameter}
                    virtualGingiva={virtualGingiva}
                    thimbleCrown={thimbleCrown}
                    waxupScan={waxupScan}
                    cervicalAdaption={cervicalAdaption}
                    materialShade={materialShade}
                    restorationPontic={restorationPontic}
                    occlusalSurface={occlusalSurface}
                    ceramicMetal={ceramicMetal}
                    onChooseImplant={onChooseImplant}
                    onChooseAbutment={onChooseAbutment}
                    onChooseScanbody={onChooseScanbody}
                  />
                )}
              </TabPanel>
              <TabPanel value={optionTab} index={1}>
                {!!indicationOptionPending ? (
                  <OptionListSkeleton type="advanced" />
                ) : (
                  <AdvancedOption advancedOption={advancedOption} advancedValue={advancedValue} />
                )}
              </TabPanel>
            </div>
          </div>
        )}
    </StyledOptionList>
  );
}

const StyledOptionList = styled.div`
  margin-top: 14px;
  height: calc(100% - 54px);
  display: flex;
  flex-direction: column;
  .optionList__title {
    margin-bottom: 20px;
  }
  .optionList__container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .optionList__body {
      overflow: auto;
    }
    .MuiAppBar-colorPrimary {
      color: #666;
      background-color: #f9f9fb;
      .MuiTabs-flexContainer {
        .optionList__tab_item {
          background-color: ${color.white};
          border: 1px solid #e1e1e7;
          border-bottom: 1px solid transparent;
          &:not(.Mui-selected) {
            border: 1px solid transparent;
            border-bottom: 1px solid #e1e1e7;
          }
        }
      }
    }
    .MuiPaper-elevation4 {
      box-shadow: none;
    }
  }
`;

export default OptionList;
